import { createContext } from 'react';
import { ISnackbarProps, SnackbarUpdate } from '.';

interface SnackbarContextType {
	snackbar: ISnackbarProps;
	/**
		- Allows setting properties like message, severity.
		- Defaults to open and success when called, passing severity undefined explicitly will render the ignite styled snackbar content
		- Warning and error severity will default to a longer auto hide duration for ease of usability (5000ms)
	 */
	setSnackbar: (newState: SnackbarUpdate) => void;
	closeSnackbar: () => void;
}

export const SnackbarContext = createContext<SnackbarContextType | null>(null);

SnackbarContext.displayName = 'SnackbarContext';
